﻿$.fn.dxCtrlWidgetAlignement = function custom_dxCtrlWidgetAlignement(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlwidgetalignement dx-ctrl");
        this.createInstance(new cdxCtrlWidgetAlignement(this, option));
    }
    return this;
}

window.cdxCtrlWidgetAlignement = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();

        var ds = ["Gauche", "Centre", "Droite"]
        if (option.allowDefaut) ds.unshift("Défaut")
        $("<div/>").appendTo(container).dxCtrlRadioButton({
            dataSource: ds,
            value: ((option.value == "left") ? "Gauche" : ((option.value == "right") ? "Droite" : ((option.value == "center") ? "Centre" : "Défaut"))),
            layout: 'horizontal',
            itemTemplate: function(itemData, itemIndex, itemElement) {
                if (itemData == "Défaut") {
                    itemElement.html("<i class='fas fa-text-slash'></i>")
                    itemElement.attr("title", "Utiliser le style par défaut")
                } else {
                    itemElement.text(itemData)
                    itemElement.attr("title", itemData)
                }
            },
            onValueChanged: function (e) {
                switch (e.value) {
                    case "Défaut": option.value = ""; break;
                    case "Gauche": option.value = "left"; break;
                    case "Centre": option.value= "center"; break;
                    case "Droite": option.value="right"; break;
                }
                option.onValueChanged({ values: [{ prop: "text-align", value: option.value }] })
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}